import React from "react";
import img_1 from "./../images/clock.png";
import img_2 from "./../images/chart.png";
import img_3 from "./../images/book.png";

export const AdvantageCart = ({ item }) => {
  return (
    <div className="w-full p-6 lg:w-1/3">
      <img
        src={item.id === 1 ? img_1 : item.id === 2 ? img_2 : img_3}
        alt="Advantage Cart img"
        className="mb-6 mx-auto w-28 h-28"
      />
      <h3 className="text-3xl font-semibold text-center mb-6">{item.title}</h3>
      <p className="text-xl text-center">{item.description}</p>
    </div>
  );
};
